(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 75557:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(18453);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 49853:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/icon.97e25e3e.svg","height":17,"width":17});

/***/ }),

/***/ 16330:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ index; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86889);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_2__);



function index(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "".concat((_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default().container), " ").concat(props.parent == "botStore" ? "botStoreLoader" : null),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "".concat((_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default().loader), " ").concat((_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default().loader3))
        })
    });
}


/***/ }),

/***/ 74231:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var useDebounce = function(value, delay) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(value), debouncedValue = ref[0], setDebouncedValue = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var handler = setTimeout(function() {
            setDebouncedValue(value);
        }, delay);
        return function() {
            clearTimeout(handler);
        };
    }, [
        value,
        delay
    ]);
    return debouncedValue;
};
/* harmony default export */ __webpack_exports__["Z"] = (useDebounce);


/***/ }),

/***/ 78581:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var _utility_endpoints__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49530);



var createSearchSuggestion = function(data) {
    var ref, ref1, ref2;
    var searchSuggestion = {
        Products: [],
        Bots: [],
        "Employee Twins": []
    };
    if ((data === null || data === void 0 ? void 0 : (ref = data.products) === null || ref === void 0 ? void 0 : ref.length) > 0) {
        var ref3;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = (data === null || data === void 0 ? void 0 : (ref3 = data.products) === null || ref3 === void 0 ? void 0 : ref3.slice(0, 10))[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var item = _step.value;
                if (item === null || item === void 0 ? void 0 : item.url) {
                    searchSuggestion.Products.push((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, item), {
                        link: "".concat(_utility_endpoints__WEBPACK_IMPORTED_MODULE_0__/* ["default"].redirectUriLogin */ .ZP.redirectUriLogin, "/product_details/").concat(item === null || item === void 0 ? void 0 : item.url, "?id=").concat(item === null || item === void 0 ? void 0 : item.id)
                    }));
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    if ((data === null || data === void 0 ? void 0 : (ref1 = data.bots) === null || ref1 === void 0 ? void 0 : ref1.length) > 0) {
        var ref4;
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = (data === null || data === void 0 ? void 0 : (ref4 = data.bots) === null || ref4 === void 0 ? void 0 : ref4.slice(0, 10))[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var item1 = _step1.value;
                searchSuggestion.Bots.push((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, item1), {
                    link: "".concat(_utility_endpoints__WEBPACK_IMPORTED_MODULE_0__/* ["default"].redirectUriLogin */ .ZP.redirectUriLogin, "botDetails?botID=").concat(window.btoa(item1 === null || item1 === void 0 ? void 0 : item1.id))
                }));
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
    }
    if ((data === null || data === void 0 ? void 0 : (ref2 = data.employeeTwins) === null || ref2 === void 0 ? void 0 : ref2.length) > 0) {
        var ref5;
        var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
        try {
            for(var _iterator2 = (data === null || data === void 0 ? void 0 : (ref5 = data.employeeTwins) === null || ref5 === void 0 ? void 0 : ref5.slice(0, 10))[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                var item2 = _step2.value;
                searchSuggestion["Employee Twins"].push((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, item2), {
                    link: "".concat(_utility_endpoints__WEBPACK_IMPORTED_MODULE_0__/* ["default"].redirectUriLogin */ .ZP.redirectUriLogin, "/Employeetwinsdetail?empTwinId=").concat(item2 === null || item2 === void 0 ? void 0 : item2.id, "&name=").concat(item2 === null || item2 === void 0 ? void 0 : item2.name, "&leadPlatform=").concat(item2 === null || item2 === void 0 ? void 0 : item2.leadPlatform)
                }));
            }
        } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                    _iterator2.return();
                }
            } finally{
                if (_didIteratorError2) {
                    throw _iteratorError2;
                }
            }
        }
    }
    return searchSuggestion;
};
/* harmony default export */ __webpack_exports__["Z"] = (createSearchSuggestion);


/***/ }),

/***/ 6748:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var pages = [
    {
        label: "Experience Zone",
        href: "cez"
    },
    {
        label: "Bot Store",
        href: "BotStore"
    },
    {
        label: "Employee Twin",
        href: "NewEmployeetwin"
    },
    {
        label: "Product",
        href: "products"
    },
    {
        label: "Approvals",
        href: "Approvals"
    },
    {
        label: "H.O.F",
        href: "hall-of-fame"
    },
    {
        label: "Contact Us",
        href: "ContactUs"
    },
    {
        label: "ROI",
        href: "return-on-investment"
    }, 
];
/* harmony default export */ __webpack_exports__["Z"] = (pages);


/***/ }),

/***/ 60344:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ config; }
/* harmony export */ });
/* provided dependency */ var process = __webpack_require__(83454);
{}// config.js
var token;
var tokenWithoutBearer;
function initializeToken() {
    if ( true && !token) {
        var auth = JSON.parse(localStorage.getItem("auth"));
        if (auth && (auth === null || auth === void 0 ? void 0 : auth.data)) {
            tokenWithoutBearer = "".concat(auth.data.accessToken);
            token = tokenWithoutBearer.replace("Bearer ", "");
        }
    }
}
// Call initializeToken to populate the token
initializeToken();
var config = {
    baseUrl: "https://automation.unilever.com/api" || 0,
    get bearerToken () {
        // Call initializeToken to ensure token is up-to-date
        initializeToken();
        return process.env.NEXT_PUBLIC_BEARER_TOKEN || token;
    }
};


/***/ }),

/***/ 99923:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var extractAxiosMessage = function(error) {
    var message = error.response && error.response.data && error.response.data.message || error.toString();
    return message;
};
/* harmony default export */ __webpack_exports__["Z"] = (extractAxiosMessage);


/***/ }),

/***/ 91345:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ useSas; }
/* harmony export */ });
/* unused harmony export useSasStore */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97582);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64529);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utility_endpoints__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49530);





var inflight = null;
var useSasStore = (0,zustand__WEBPACK_IMPORTED_MODULE_2__/* .create */ .Ue)(function(set, get) {
    return {
        sasToken: "",
        sasUrl: "",
        loading: false,
        attempted: false,
        error: null,
        // Fetch Read-Only SAS Token
        fetchReadToken: /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
            var sasToken;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
                sasToken = get().sasToken;
                if (sasToken) return [
                    2,
                    sasToken
                ];
                if (inflight) return [
                    2,
                    inflight
                ]; // dedupe concurrent calls
                set({
                    loading: true,
                    error: null
                });
                inflight = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
                    var res, data, err;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    3,
                                    4,
                                    5
                                ]);
                                return [
                                    4,
                                    fetch("".concat(_utility_endpoints__WEBPACK_IMPORTED_MODULE_1__/* ["default"].baseUrl */ .ZP.baseUrl, "/sas/read"))
                                ];
                            case 1:
                                res = _state.sent();
                                if (!res.ok) throw new Error("HTTP ".concat(res.status));
                                return [
                                    4,
                                    res.json()
                                ];
                            case 2:
                                data = _state.sent();
                                if (!data.sasToken) throw new Error("Response missing sasToken");
                                set({
                                    sasToken: data.sasToken,
                                    sasUrl: data.sasUrl,
                                    loading: false,
                                    attempted: true
                                });
                                return [
                                    2,
                                    data.sasToken
                                ];
                            case 3:
                                err = _state.sent();
                                console.error("Failed to load read SAS token:", err);
                                set({
                                    error: err,
                                    loading: false,
                                    attempted: true
                                });
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                inflight = null;
                                return [
                                    7
                                ];
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                })();
                return [
                    2,
                    inflight
                ];
            });
        }),
        // Builds a blob URL with the current read SAS token
        getBlobUrl: function(blobPath) {
            if (!blobPath) return "";
            var ref = get(), sasToken = ref.sasToken, attempted = ref.attempted;
            // Trigger token fetch in background if missing (only once, never during render)
            if (!sasToken && !attempted && !inflight && "object" !== "undefined") {
                queueMicrotask(function() {
                    return get().fetchReadToken();
                });
            }
            // Full URL: strip any old query string and append current read SAS token
            if (blobPath.startsWith("http://") || blobPath.startsWith("https://")) {
                var baseUrl = blobPath.split("?")[0];
                return sasToken ? "".concat(baseUrl, "?").concat(sasToken) : baseUrl;
            }
            var accountName = "bnlwestgunileveraf01092" || 0;
            var containerName = "botstorevideo";
            var cleanPath = blobPath.startsWith("/") ? blobPath.slice(1) : blobPath;
            var encodedPath = cleanPath.split("/").map(function(part) {
                return encodeURIComponent(part);
            }).join("/");
            var baseUrl1 = "https://".concat(accountName, ".blob.core.windows.net/").concat(containerName, "/").concat(encodedPath);
            return sasToken ? "".concat(baseUrl1, "?").concat(sasToken) : baseUrl1;
        },
        // Request a short-lived full-access/admin token when needed
        fetchAdminToken: /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
            var minutes, res, data, err;
            var _arguments = arguments;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        minutes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : 15;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4,
                            fetch("".concat(_utility_endpoints__WEBPACK_IMPORTED_MODULE_1__/* ["default"].baseUrl */ .ZP.baseUrl, "/sas/admin?minutes=").concat(minutes))
                        ];
                    case 2:
                        res = _state.sent();
                        return [
                            4,
                            res.json()
                        ];
                    case 3:
                        data = _state.sent();
                        if (!res.ok) throw new Error(data.error || "Failed to fetch admin token");
                        return [
                            2,
                            data
                        ];
                    case 4:
                        err = _state.sent();
                        console.error("Error fetching short-lived admin SAS token:", err);
                        throw err;
                    case 5:
                        return [
                            2
                        ];
                }
            });
        })
    };
});
var useSas = function() {
    var sasToken = useSasStore(function(s) {
        return s.sasToken;
    });
    var sasUrl = useSasStore(function(s) {
        return s.sasUrl;
    });
    var loading = useSasStore(function(s) {
        return s.loading;
    });
    var error = useSasStore(function(s) {
        return s.error;
    });
    var attempted = useSasStore(function(s) {
        return s.attempted;
    });
    var fetchReadToken = useSasStore(function(s) {
        return s.fetchReadToken;
    });
    var getBlobUrl = useSasStore(function(s) {
        return s.getBlobUrl;
    });
    var fetchAdminToken = useSasStore(function(s) {
        return s.fetchAdminToken;
    });
    // Fetch once if missing when the hook is used
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (!sasToken && !loading && !attempted) {
            fetchReadToken();
        }
    }, [
        sasToken,
        loading,
        attempted,
        fetchReadToken
    ]);
    return {
        sasToken: sasToken,
        sasUrl: sasUrl,
        loading: loading,
        error: error,
        getBlobUrl: getBlobUrl,
        fetchAdminToken: fetchAdminToken,
        fetchReadToken: fetchReadToken
    };
};


/***/ }),

/***/ 18453:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages_0; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/home/assets/icon.svg
var icon = __webpack_require__(49853);
// EXTERNAL MODULE: ./components/shared/utils/Figure.js
var Figure = __webpack_require__(16223);
// EXTERNAL MODULE: ./components/hapAnalytics/utils/useDebounce.js
var useDebounce = __webpack_require__(74231);
// EXTERNAL MODULE: ./components/shared/config.js
var config = __webpack_require__(60344);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./components/shared/utils/extractAxiosError.js
var extractAxiosError = __webpack_require__(99923);
// EXTERNAL MODULE: ./components/home/createSearchSuggestion.js
var createSearchSuggestion = __webpack_require__(78581);
// EXTERNAL MODULE: ./node_modules/react-icons/pi/index.esm.js
var index_esm = __webpack_require__(96225);
// EXTERNAL MODULE: ./components/home/pages.js
var pages = __webpack_require__(6748);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-icons/vsc/index.esm.js
var vsc_index_esm = __webpack_require__(14578);
// EXTERNAL MODULE: ./lib/store/useSasStore.js
var useSasStore = __webpack_require__(91345);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 7 modules
var styled_components_browser_esm = __webpack_require__(15437);
;// CONCATENATED MODULE: ./components/home/styles.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-rows: ",
        ";\n  transition:\n    grid-template-rows 350ms ease,\n    opacity 250ms ease;\n  opacity: ",
        ";\n  overflow: hidden;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-height: 0;\n  max-height: 16rem;\n  overflow-y: auto;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-rows: ",
        ";\n  transition: grid-template-rows 300ms ease;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-height: 0;\n  overflow: hidden;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}

var SearchDropdown = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b84a9807-0"
})(_templateObject(), function(param) {
    var $open = param.$open;
    return $open ? "1fr" : "0fr";
}, function(param) {
    var $open = param.$open;
    return $open ? 1 : 0;
});
var SearchDropdownInner = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b84a9807-1"
})(_templateObject1());
var SectionContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b84a9807-2"
})(_templateObject2(), function(param) {
    var $open = param.$open;
    return $open ? "1fr" : "0fr";
});
var SectionContentInner = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b84a9807-3"
})(_templateObject3());

// EXTERNAL MODULE: ./utility/endpoints.js
var endpoints = __webpack_require__(49530);
;// CONCATENATED MODULE: ./components/home/IndexSearchContainer.jsx




















var IndexSearchContainer = function() {
    var ref = (0,react.useState)({}), searchResults = ref[0], setSearchResults = ref[1];
    var ref1 = (0,react.useState)(""), searchTerm = ref1[0], setSearchTerm = ref1[1];
    var inputRef = (0,react.useRef)(null);
    var ref2 = (0,react.useState)([]), minimize = ref2[0], setMinimize = ref2[1];
    var sasToken = (0,useSasStore/* useSas */.k)().sasToken;
    var router = (0,next_router.useRouter)();
    var debouncedSearch = (0,useDebounce/* default */.Z)(searchTerm, 500);
    var fous = function() {
        inputRef.current.focus();
    };
    (0,react.useEffect)(function() {
        if (true) {
            document.body.style.overflow = "hidden";
        }
        return function() {
            if (true) {
                document.body.style.overflow = "unset";
            }
        };
    }, []);
    var handleMinimize = function(key) {
        if (minimize.includes(key)) {
            setMinimize(minimize.filter(function(item) {
                return item !== key;
            }));
        } else {
            setMinimize((0,_to_consumable_array/* default */.Z)(minimize).concat([
                key
            ]));
        }
    };
    var goToLink = function(link) {
        if (!link) return;
        window.open(link, "_blank");
    };
    var handleSearch = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var auth, ref, ref1, res, ref2, error, message;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (true) {
                            auth = JSON.parse(localStorage.getItem("auth")).data;
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            axios_default().get("".concat(config/* config.baseUrl */.v.baseUrl, "/index-search?q=").concat(debouncedSearch), {
                                headers: {
                                    Authorization: auth === null || auth === void 0 ? void 0 : auth.accessToken
                                }
                            })
                        ];
                    case 2:
                        res = _state.sent();
                        if (((ref = res.data) === null || ref === void 0 ? void 0 : ref.status) === "success") {
                            ;
                            setSearchResults((0,createSearchSuggestion/* default */.Z)((ref2 = res.data) === null || ref2 === void 0 ? void 0 : ref2.data));
                        }
                        if (((ref1 = res.data) === null || ref1 === void 0 ? void 0 : ref1.message) === "Error while authentication") {
                            router.push("/login");
                        }
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        message = (0,extractAxiosError/* default */.Z)(error);
                        console.error("message", message);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSearch() {
            return _ref.apply(this, arguments);
        };
    }();
    var loadSearchPage = function() {
        if (!searchTerm) return;
        router.push({
            pathname: "/search",
            query: {
                q: searchTerm
            }
        });
    };
    (0,react.useEffect)(function() {
        if (debouncedSearch) {
            handleSearch();
        } else {
            setSearchResults({});
        }
    }, [
        debouncedSearch
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        style: {
            background: "linear-gradient(356deg, rgba(192, 207, 252, 1) 0%, rgba(214, 227, 252, 1) 30%, rgba(227, 235, 252, 1) 70%, rgba(229, 240, 252, 1) 100%)"
        },
        className: "max-w-screen max-h-screen w-screen h-screen flex justify-center items-center overflow-hidden fixed top-0 left-0",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "min-w-[26rem] w-[60%]",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex justify-center items-center gap-4",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                        style: {
                            mixBlendMode: "multiply"
                        },
                        autoPlay: true,
                        loop: true,
                        muted: true,
                        src: "https://bnlwestgunileveraf01092.blob.core.windows.net/botstorevideo/hap_home/HAP.mp4?".concat(sasToken),
                        className: "w-[350px] h-[30px] scale-[1.1]"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    onClick: function(e) {
                        e.stopPropagation();
                        focus();
                    },
                    className: "w-full !border !border-[#C8D7FF] flex items-center gap-3 p-1 bg-white rounded-full mt-3 relative shadow-sm",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Figure/* Figure */.B, {
                            className: "ml-2 w-7 h-7 animate-spin",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: icon/* default */.Z
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                            onChange: function(e) {
                                return setSearchTerm(e.target.value);
                            },
                            value: searchTerm,
                            ref: inputRef,
                            type: "text",
                            className: "w-full outline-none h-full text-[17px] font-unilever-shilling-normal"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            onClick: function(e) {
                                e.stopPropagation();
                                loadSearchPage();
                            },
                            className: "aspect-square w-12 h-12 bg-[rgba(200,215,255,0.5)] rounded-full flex justify-center items-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(vsc_index_esm/* VscSend */.NQj, {
                                className: "text-primary w-6 h-6"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchDropdown, {
                            $open: Object.keys(searchResults).length > 0,
                            className: "absolute left-0 top-16 w-full rounded-xl bg-white shadow-lg z-50",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchDropdownInner, {
                                children: Object.keys(searchResults).map(function(key) {
                                    if (!searchResults[key].length) return null;
                                    var isOpen = !minimize.includes(key);
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "p-3 border-b last:border-b-0",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex items-center gap-2",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "text-primary",
                                                        children: key
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* PiCaretRightBold */.hmH, {
                                                        onClick: function() {
                                                            return handleMinimize(key);
                                                        },
                                                        className: "cursor-pointer transition-transform duration-300 text-primary ".concat(isOpen ? "rotate-90" : "")
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionContent, {
                                                $open: isOpen,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionContentInner, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "p-2 flex flex-col gap-2",
                                                        children: searchResults[key].map(function(item, index) {
                                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                                                onClick: function() {
                                                                    return goToLink(item === null || item === void 0 ? void 0 : item.link);
                                                                },
                                                                className: "text-[12px] p-2 rounded-md cursor-pointer hover:bg-[rgba(200,215,255,0.2)] transition-colors",
                                                                children: key === "Bots" ? "Bot ID: ".concat(item === null || item === void 0 ? void 0 : item.botExternalId, " Process Name: ").concat(item === null || item === void 0 ? void 0 : item.name) : item === null || item === void 0 ? void 0 : item.name
                                                            }, index);
                                                        })
                                                    })
                                                })
                                            })
                                        ]
                                    }, key);
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex flex-wrap items-center justify-center gap-3 mt-4",
                    children: pages/* default.map */.Z.map(function(item, idx) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                            onClick: function() {
                                return router.push("/".concat(item.href));
                            },
                            className: "text-[12px] px-4 py-2 rounded-full !border !border-[#C8D7FF] bg-white cursor-pointer text-primary hover:scale-[1.15] transition-all duration-300 shadow-sm",
                            children: item === null || item === void 0 ? void 0 : item.label
                        }, idx);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var home_IndexSearchContainer = (IndexSearchContainer);

// EXTERNAL MODULE: ./redux/global/actions.js
var actions = __webpack_require__(39471);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./node_modules/redux/es/redux.js
var redux = __webpack_require__(14890);
// EXTERNAL MODULE: ./pages/successModal/index.jsx
var successModal = __webpack_require__(99696);
// EXTERNAL MODULE: ./components/Loader/index.jsx
var Loader = __webpack_require__(16330);
;// CONCATENATED MODULE: ./pages/index.js





//code for session









var Home = function(props) {
    //code for session
    var router = (0,next_router.useRouter)();
    var currentUrl = router.asPath;
    var ref = (0,react.useState)(false), successModal1 = ref[0], setSuccessModal1 = ref[1];
    var checkAuthorization = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var authData, auth, data, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        authData = JSON.parse(localStorage.getItem("auth"));
                        if (!authData || !authData.data) {
                            // Handle the case when authData or authData.data is falsy
                            props.sessionTimeOutCheck(true);
                            return [
                                2
                            ]; // Return without making the API call
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        auth = JSON.parse(localStorage.getItem("auth")).data;
                        return [
                            4,
                            axios_default()({
                                method: "GET",
                                url: "".concat(endpoints/* default.baseUrl */.ZP.baseUrl, "/roi/checkAuthorization"),
                                headers: {
                                    Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
                                }
                            })
                        ];
                    case 2:
                        data = _state.sent().data;
                        if (data.data.code === 200) {} else if (data.code === 403) {
                            setTimeout(function() {
                                props.sessionTimeOutCheck(true);
                            }, 1000);
                        } else {
                            props.sessionTimeOutCheck(true);
                        }
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        console.log("Error in Authorization", error);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function checkAuthorization() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        checkAuthorization();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: props.routeChangeState ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            style: {
                height: "800px"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader["default"], {})
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(home_IndexSearchContainer, {}),
                props.session ? /*#__PURE__*/ (0,jsx_runtime.jsx)(successModal["default"], {
                    message: "Session Expired",
                    title: "Login Session Status",
                    session: props.session,
                    sessionTimeOutCheck: props.sessionTimeOutCheck,
                    setSuccessModal: setSuccessModal1,
                    fail: true,
                    checkoutSessionCheck: "checkoutSessionCheck"
                }) : null
            ]
        })
    });
};
//code for session
var mapStateToProps = function(state) {
    return {
        session: state.session.session
    };
};
function mapDispatchToProps(dispatch) {
    return {
        sessionTimeOutCheck: (0,redux/* bindActionCreators */.DE)(actions/* sessionTimeOutCheck */.Iy, dispatch),
        checkExpiry: (0,redux/* bindActionCreators */.DE)(actions/* checkExpiry */.Wr, dispatch)
    };
}
/* harmony default export */ var pages_0 = ((0,es/* connect */.$j)(mapStateToProps, mapDispatchToProps)(Home));


/***/ }),

/***/ 86889:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"liveStatus":"Loader_liveStatus__6tz3I","rejectedStatus":"Loader_rejectedStatus__LW79z","retiredStatus":"Loader_retiredStatus__f__Yr","onHoldStatus":"Loader_onHoldStatus__3UCMB","in-ProgressStatus":"Loader_in-ProgressStatus__koBwl","inProgressStatus":"Loader_inProgressStatus__AQ4bT","uATStatus":"Loader_uATStatus__oSeYO","initialDemandStatus":"Loader_initialDemandStatus__XPTZ0","designFeasibilityStatus":"Loader_designFeasibilityStatus__6TbBG","feasibilityStatus":"Loader_feasibilityStatus__YMT7p","designStatus":"Loader_designStatus__tX_QZ","ideasStatus":"Loader_ideasStatus__Uwaz4","buildStatus":"Loader_buildStatus__fC8Tv","container":"Loader_container__cy6a_","loader":"Loader_loader__Qiyey","loader3":"Loader_loader3__IpAyx","load3":"Loader_load3__Ve_W2","load":"Loader_load__XGt1g"};

/***/ }),

/***/ 88357:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "w_": function() { return /* reexport */ GenIcon; }
});

// UNUSED EXPORTS: DefaultContext, IconBase, IconContext, IconsManifest

;// CONCATENATED MODULE: ./node_modules/react-icons/lib/esm/iconsManifest.js
var IconsManifest = [
  {
    "id": "ci",
    "name": "Circum Icons",
    "projectUrl": "https://circumicons.com/",
    "license": "MPL-2.0 license",
    "licenseUrl": "https://github.com/Klarr-Agency/Circum-Icons/blob/main/LICENSE"
  },
  {
    "id": "fa",
    "name": "Font Awesome 5",
    "projectUrl": "https://fontawesome.com/",
    "license": "CC BY 4.0 License",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
  },
  {
    "id": "fa6",
    "name": "Font Awesome 6",
    "projectUrl": "https://fontawesome.com/",
    "license": "CC BY 4.0 License",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
  },
  {
    "id": "io",
    "name": "Ionicons 4",
    "projectUrl": "https://ionicons.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
  },
  {
    "id": "io5",
    "name": "Ionicons 5",
    "projectUrl": "https://ionicons.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
  },
  {
    "id": "md",
    "name": "Material Design icons",
    "projectUrl": "http://google.github.io/material-design-icons/",
    "license": "Apache License Version 2.0",
    "licenseUrl": "https://github.com/google/material-design-icons/blob/master/LICENSE"
  },
  {
    "id": "ti",
    "name": "Typicons",
    "projectUrl": "http://s-ings.com/typicons/",
    "license": "CC BY-SA 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0/"
  },
  {
    "id": "go",
    "name": "Github Octicons icons",
    "projectUrl": "https://octicons.github.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/primer/octicons/blob/master/LICENSE"
  },
  {
    "id": "fi",
    "name": "Feather",
    "projectUrl": "https://feathericons.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/feathericons/feather/blob/master/LICENSE"
  },
  {
    "id": "lu",
    "name": "Lucide",
    "projectUrl": "https://lucide.dev/",
    "license": "ISC",
    "licenseUrl": "https://github.com/lucide-icons/lucide/blob/main/LICENSE"
  },
  {
    "id": "gi",
    "name": "Game Icons",
    "projectUrl": "https://game-icons.net/",
    "license": "CC BY 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/3.0/"
  },
  {
    "id": "wi",
    "name": "Weather Icons",
    "projectUrl": "https://erikflowers.github.io/weather-icons/",
    "license": "SIL OFL 1.1",
    "licenseUrl": "http://scripts.sil.org/OFL"
  },
  {
    "id": "di",
    "name": "Devicons",
    "projectUrl": "https://vorillaz.github.io/devicons/",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "ai",
    "name": "Ant Design Icons",
    "projectUrl": "https://github.com/ant-design/ant-design-icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "bs",
    "name": "Bootstrap Icons",
    "projectUrl": "https://github.com/twbs/icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "ri",
    "name": "Remix Icon",
    "projectUrl": "https://github.com/Remix-Design/RemixIcon",
    "license": "Apache License Version 2.0",
    "licenseUrl": "http://www.apache.org/licenses/"
  },
  {
    "id": "fc",
    "name": "Flat Color Icons",
    "projectUrl": "https://github.com/icons8/flat-color-icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "gr",
    "name": "Grommet-Icons",
    "projectUrl": "https://github.com/grommet/grommet-icons",
    "license": "Apache License Version 2.0",
    "licenseUrl": "http://www.apache.org/licenses/"
  },
  {
    "id": "hi",
    "name": "Heroicons",
    "projectUrl": "https://github.com/tailwindlabs/heroicons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "hi2",
    "name": "Heroicons 2",
    "projectUrl": "https://github.com/tailwindlabs/heroicons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "si",
    "name": "Simple Icons",
    "projectUrl": "https://simpleicons.org/",
    "license": "CC0 1.0 Universal",
    "licenseUrl": "https://creativecommons.org/publicdomain/zero/1.0/"
  },
  {
    "id": "sl",
    "name": "Simple Line Icons",
    "projectUrl": "https://thesabbir.github.io/simple-line-icons/",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "im",
    "name": "IcoMoon Free",
    "projectUrl": "https://github.com/Keyamoon/IcoMoon-Free",
    "license": "CC BY 4.0 License",
    "licenseUrl": "https://github.com/Keyamoon/IcoMoon-Free/blob/master/License.txt"
  },
  {
    "id": "bi",
    "name": "BoxIcons",
    "projectUrl": "https://github.com/atisawd/boxicons",
    "license": "CC BY 4.0 License",
    "licenseUrl": "https://github.com/atisawd/boxicons/blob/master/LICENSE"
  },
  {
    "id": "cg",
    "name": "css.gg",
    "projectUrl": "https://github.com/astrit/css.gg",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "vsc",
    "name": "VS Code Icons",
    "projectUrl": "https://github.com/microsoft/vscode-codicons",
    "license": "CC BY 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
  },
  {
    "id": "tb",
    "name": "Tabler Icons",
    "projectUrl": "https://github.com/tabler/tabler-icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "tfi",
    "name": "Themify Icons",
    "projectUrl": "https://github.com/lykmapipo/themify-icons",
    "license": "MIT",
    "licenseUrl": "https://github.com/thecreation/standard-icons/blob/master/modules/themify-icons/LICENSE"
  },
  {
    "id": "rx",
    "name": "Radix Icons",
    "projectUrl": "https://icons.radix-ui.com",
    "license": "MIT",
    "licenseUrl": "https://github.com/radix-ui/icons/blob/master/LICENSE"
  },
  {
    "id": "pi",
    "name": "Phosphor Icons",
    "projectUrl": "https://github.com/phosphor-icons/core",
    "license": "MIT",
    "licenseUrl": "https://github.com/phosphor-icons/core/blob/main/LICENSE"
  },
  {
    "id": "lia",
    "name": "Icons8 Line Awesome",
    "projectUrl": "https://icons8.com/line-awesome",
    "license": "MIT",
    "licenseUrl": "https://github.com/icons8/line-awesome/blob/master/LICENSE.md"
  }
]
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/react-icons/lib/esm/iconContext.js

var DefaultContext = {
  color: undefined,
  size: undefined,
  className: undefined,
  style: undefined,
  attr: undefined
};
var IconContext = react.createContext && react.createContext(DefaultContext);
;// CONCATENATED MODULE: ./node_modules/react-icons/lib/esm/iconBase.js
var __assign = undefined && undefined.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};


function Tree2Element(tree) {
  return tree && tree.map(function (node, i) {
    return react.createElement(node.tag, __assign({
      key: i
    }, node.attr), Tree2Element(node.child));
  });
}
function GenIcon(data) {
  // eslint-disable-next-line react/display-name
  return function (props) {
    return react.createElement(IconBase, __assign({
      attr: __assign({}, data.attr)
    }, props), Tree2Element(data.child));
  };
}
function IconBase(props) {
  var elem = function (conf) {
    var attr = props.attr,
      size = props.size,
      title = props.title,
      svgProps = __rest(props, ["attr", "size", "title"]);
    var computedSize = size || conf.size || "1em";
    var className;
    if (conf.className) className = conf.className;
    if (props.className) className = (className ? className + " " : "") + props.className;
    return react.createElement("svg", __assign({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, conf.attr, attr, svgProps, {
      className: className,
      style: __assign(__assign({
        color: props.color || conf.color
      }, conf.style), props.style),
      height: computedSize,
      width: computedSize,
      xmlns: "http://www.w3.org/2000/svg"
    }), title && react.createElement("title", null, title), props.children);
  };
  return IconContext !== undefined ? react.createElement(IconContext.Consumer, null, function (conf) {
    return elem(conf);
  }) : elem(DefaultContext);
}
;// CONCATENATED MODULE: ./node_modules/react-icons/lib/esm/index.js




/***/ }),

/***/ 11041:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */


var React = __webpack_require__(67294);
function is(x, y) {
  return (x === y && (0 !== x || 1 / x === 1 / y)) || (x !== x && y !== y);
}
var objectIs = "function" === typeof Object.is ? Object.is : is,
  useState = React.useState,
  useEffect = React.useEffect,
  useLayoutEffect = React.useLayoutEffect,
  useDebugValue = React.useDebugValue;
function useSyncExternalStore$2(subscribe, getSnapshot) {
  var value = getSnapshot(),
    _useState = useState({ inst: { value: value, getSnapshot: getSnapshot } }),
    inst = _useState[0].inst,
    forceUpdate = _useState[1];
  useLayoutEffect(
    function () {
      inst.value = value;
      inst.getSnapshot = getSnapshot;
      checkIfSnapshotChanged(inst) && forceUpdate({ inst: inst });
    },
    [subscribe, value, getSnapshot]
  );
  useEffect(
    function () {
      checkIfSnapshotChanged(inst) && forceUpdate({ inst: inst });
      return subscribe(function () {
        checkIfSnapshotChanged(inst) && forceUpdate({ inst: inst });
      });
    },
    [subscribe]
  );
  useDebugValue(value);
  return value;
}
function checkIfSnapshotChanged(inst) {
  var latestGetSnapshot = inst.getSnapshot;
  inst = inst.value;
  try {
    var nextValue = latestGetSnapshot();
    return !objectIs(inst, nextValue);
  } catch (error) {
    return !0;
  }
}
function useSyncExternalStore$1(subscribe, getSnapshot) {
  return getSnapshot();
}
var shim =
  "undefined" === typeof window ||
  "undefined" === typeof window.document ||
  "undefined" === typeof window.document.createElement
    ? useSyncExternalStore$1
    : useSyncExternalStore$2;
exports.useSyncExternalStore =
  void 0 !== React.useSyncExternalStore ? React.useSyncExternalStore : shim;


/***/ }),

/***/ 60743:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */


var React = __webpack_require__(67294),
  shim = __webpack_require__(54652);
function is(x, y) {
  return (x === y && (0 !== x || 1 / x === 1 / y)) || (x !== x && y !== y);
}
var objectIs = "function" === typeof Object.is ? Object.is : is,
  useSyncExternalStore = shim.useSyncExternalStore,
  useRef = React.useRef,
  useEffect = React.useEffect,
  useMemo = React.useMemo,
  useDebugValue = React.useDebugValue;
exports.useSyncExternalStoreWithSelector = function (
  subscribe,
  getSnapshot,
  getServerSnapshot,
  selector,
  isEqual
) {
  var instRef = useRef(null);
  if (null === instRef.current) {
    var inst = { hasValue: !1, value: null };
    instRef.current = inst;
  } else inst = instRef.current;
  instRef = useMemo(
    function () {
      function memoizedSelector(nextSnapshot) {
        if (!hasMemo) {
          hasMemo = !0;
          memoizedSnapshot = nextSnapshot;
          nextSnapshot = selector(nextSnapshot);
          if (void 0 !== isEqual && inst.hasValue) {
            var currentSelection = inst.value;
            if (isEqual(currentSelection, nextSnapshot))
              return (memoizedSelection = currentSelection);
          }
          return (memoizedSelection = nextSnapshot);
        }
        currentSelection = memoizedSelection;
        if (objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
        var nextSelection = selector(nextSnapshot);
        if (void 0 !== isEqual && isEqual(currentSelection, nextSelection))
          return (memoizedSnapshot = nextSnapshot), currentSelection;
        memoizedSnapshot = nextSnapshot;
        return (memoizedSelection = nextSelection);
      }
      var hasMemo = !1,
        memoizedSnapshot,
        memoizedSelection,
        maybeGetServerSnapshot =
          void 0 === getServerSnapshot ? null : getServerSnapshot;
      return [
        function () {
          return memoizedSelector(getSnapshot());
        },
        null === maybeGetServerSnapshot
          ? void 0
          : function () {
              return memoizedSelector(maybeGetServerSnapshot());
            }
      ];
    },
    [getSnapshot, getServerSnapshot, selector, isEqual]
  );
  var value = useSyncExternalStore(subscribe, instRef[0], instRef[1]);
  useEffect(
    function () {
      inst.hasValue = !0;
      inst.value = value;
    },
    [value]
  );
  useDebugValue(value);
  return value;
};


/***/ }),

/***/ 54652:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(11041);
} else {}


/***/ }),

/***/ 28258:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(60743);
} else {}


/***/ }),

/***/ 64529:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Ue": function() { return /* binding */ create; }
});

// UNUSED EXPORTS: createStore, default, useStore

;// CONCATENATED MODULE: ./node_modules/zustand/esm/vanilla.mjs
const createStoreImpl = (createState) => {
  let state;
  const listeners = /* @__PURE__ */ new Set();
  const setState = (partial, replace) => {
    const nextState = typeof partial === "function" ? partial(state) : partial;
    if (!Object.is(nextState, state)) {
      const previousState = state;
      state = (replace != null ? replace : typeof nextState !== "object" || nextState === null) ? nextState : Object.assign({}, state, nextState);
      listeners.forEach((listener) => listener(state, previousState));
    }
  };
  const getState = () => state;
  const getInitialState = () => initialState;
  const subscribe = (listener) => {
    listeners.add(listener);
    return () => listeners.delete(listener);
  };
  const destroy = () => {
    if (( false ? 0 : void 0) !== "production") {
      console.warn(
        "[DEPRECATED] The `destroy` method will be unsupported in a future version. Instead use unsubscribe function returned by subscribe. Everything will be garbage-collected if store is garbage-collected."
      );
    }
    listeners.clear();
  };
  const api = { setState, getState, getInitialState, subscribe, destroy };
  const initialState = state = createState(setState, getState, api);
  return api;
};
const createStore = (createState) => createState ? createStoreImpl(createState) : createStoreImpl;
var vanilla = (createState) => {
  if (( false ? 0 : void 0) !== "production") {
    console.warn(
      "[DEPRECATED] Default export is deprecated. Instead use import { createStore } from 'zustand/vanilla'."
    );
  }
  return createStore(createState);
};



// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/zustand/node_modules/use-sync-external-store/shim/with-selector.js
var with_selector = __webpack_require__(28258);
;// CONCATENATED MODULE: ./node_modules/zustand/esm/index.mjs





const { useDebugValue } = react;
const { useSyncExternalStoreWithSelector } = with_selector;
let didWarnAboutEqualityFn = false;
const identity = (arg) => arg;
function useStore(api, selector = identity, equalityFn) {
  if (( false ? 0 : void 0) !== "production" && equalityFn && !didWarnAboutEqualityFn) {
    console.warn(
      "[DEPRECATED] Use `createWithEqualityFn` instead of `create` or use `useStoreWithEqualityFn` instead of `useStore`. They can be imported from 'zustand/traditional'. https://github.com/pmndrs/zustand/discussions/1937"
    );
    didWarnAboutEqualityFn = true;
  }
  const slice = useSyncExternalStoreWithSelector(
    api.subscribe,
    api.getState,
    api.getServerState || api.getInitialState,
    selector,
    equalityFn
  );
  useDebugValue(slice);
  return slice;
}
const createImpl = (createState) => {
  if (( false ? 0 : void 0) !== "production" && typeof createState !== "function") {
    console.warn(
      "[DEPRECATED] Passing a vanilla store will be unsupported in a future version. Instead use `import { useStore } from 'zustand'`."
    );
  }
  const api = typeof createState === "function" ? createStore(createState) : createState;
  const useBoundStore = (selector, equalityFn) => useStore(api, selector, equalityFn);
  Object.assign(useBoundStore, api);
  return useBoundStore;
};
const create = (createState) => createState ? createImpl(createState) : createImpl;
var esm_react = (createState) => {
  if (( false ? 0 : void 0) !== "production") {
    console.warn(
      "[DEPRECATED] Default export is deprecated. Instead use `import { create } from 'zustand'`."
    );
  }
  return create(createState);
};




/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7627,2876,9774,2888,179], function() { return __webpack_exec__(75557); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);